import Main from '@/components/main';

export default {
    path: '/stat-analyze',
    name: 'stat-analyze',
    meta: {
        icon: 'ios-man',
        title: '统计分析',
        showAlways: true
    },
    component: Main,
    children: [
        {
            path: 'customer-analyze',
            name: 'customer-analyze',
            meta: {
                icon: 'ios-apps',
                title: '客户统计分析',
                notCache: true,
                access: ['S', 'J'],
                items: []
            },
            component: () => import('@/view/stat-analyze/customer-analyze/customer-analyze')
        },
        {
            path: 'customer-login-stat',
            name: 'customer-login-stat',
            meta: {
                icon: 'ios-apps',
                title: '客户登录统计',
                notCache: true,
                access: ['S', 'J'],
                items: []
            },
            component: () => import('@/view/stat-analyze/customer-login-stat/customer-login-stat')
        },
        {
            path: 'salesStatisticalAnalysis',
            name: 'salesStatisticalAnalysis',
            meta: {
                icon: 'ios-apps',
                title: '销售统计分析',
                notCache: false,
                access: ['S', 'B', 'G', 'P', 'D', 'J', 'I'],
                items: []
            },
            component: () => import('@/view/stat-analyze/sales-statistical-analysis/sales-statistical-analysis')
        },
        {
            path: 'salesStatisticalCharts',
            name: 'salesStatisticalCharts',
            meta: {
                icon: 'ios-apps',
                title: '销售统计图表',
                notCache: false,
                access: ['S', 'B', 'G', 'P', 'D', 'J', 'I'],
                items: []
            },
            component: () => import('@/view/stat-analyze/sales-statistical-charts/sales-statistical-charts.vue')
        }
        // ,
        // {
        //     path: 'refundStatisticalAnalysis',
        //     name: 'refundStatisticalAnalysis',
        //     meta: {
        //         icon: 'ios-apps',
        //         title: '退款单统计分析',
        //         notCache: false,
        //         access: ['S', 'B', 'G', 'P', 'D', 'J', 'I'],
        //         items: []
        //     },
        //     component: () => import('@/view/stat-analyze/sales-statistical-analysis/refund-statistical-analysis')
        // }
        
    ]
};
